import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import STRING_KEYS from '../../../../../language/keys';
import { convertMonthToFloatYears } from '../../../../../utils';
import { RolesList } from './roles-list/roles-list.component';
import {
  Container,
  Label,
  Title,
  MarkedTitle,
  RolesListWrapper,
} from './experience-by-role-widget.styled';
import { ExperiencePieChart } from './experience-pie-chart/experience-pie-chart.component';

type ExperienceByRoleProps = {
    roleList: ExperienceByRole[],
}

export const ExperienceByRole = ({
  roleList,
}:ExperienceByRoleProps): JSX.Element => {
  const { t: translate } = useTranslation();

  const totalMonths = roleList
    .reduce((
      prev,
      current,
    ) => prev + current.tenureInMonths,
    0);

  const chartData = useMemo(
    () => roleList.map((role) => ({ title: role.jobTitle, durationInMonths: role.tenureInMonths })),
    [roleList]);

  return (
    <Container>
      <Label>{translate(STRING_KEYS.EXPERIENCE_BREAKDOWN)}</Label>
      <Title>{translate(STRING_KEYS.RELEVANT)}
        <MarkedTitle>
          {translate(STRING_KEYS.EXPERIENCE)}
        </MarkedTitle>
      </Title>
      <ExperiencePieChart
        data={ chartData }
        totalYears={ convertMonthToFloatYears(totalMonths) }
      />
      <RolesListWrapper>
        <RolesList data={ chartData } />
      </RolesListWrapper>
    </Container>
  );
};
